import { render, staticRenderFns } from "./SelectColumn.vue?vue&type=template&id=8857e58c&scoped=true&"
import script from "./SelectColumn.vue?vue&type=script&lang=js&"
export * from "./SelectColumn.vue?vue&type=script&lang=js&"
import style0 from "./SelectColumn.vue?vue&type=style&index=0&id=8857e58c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8857e58c",
  null
  
)

export default component.exports